<script>
export default {
  name: "DepositReceiptPrint",

  data() {
    return {
      patientDeposits: [],
      patient: {},
      footerMessage: {},
    };
  },

  computed: {
    totalAmount() {
      if (!this.patientDeposits.length) return 0;

      return this.patientDeposits
        .map((pD) => parseFloat(pD.depositAmount))
        .reduce((sum, amt) => sum + amt);
    },
  },

  mounted() {
    this.$root.loading = true;
    Promise.allSettled([ 
        this.fetchDeposits(), this.fetchPatient(), this.fetchMessage(),
    ])
      .then(() => {
        this.$root.loading = false;
        setTimeout(() => {
          window.print();
        }, 250);
      })
      .catch(() => {
        this.$root.loading = false;
      });
  },

  methods: {
    fetchPatient() {
      const queryString = `?PatientID=${this.$route.query.PatientID}`;

      return this.$http
        .get(`PatientRegistration/GetSpecificPatient${queryString}`)
        .then((response) => {
          this.patient = response.data.length ? response.data[0] : {};
        })
        .catch(() => {});
    },

    fetchDeposits() {
      return this.$http
        .get(
          `Accounts/GetDepositforReceiptNo?ReceiptNo=${this.$route.query.ReceiptNo}`
        )
        .then((response) => {
          this.patientDeposits = response.data;
        })
        .catch(() => {});
    },

    fetchMessage() {
      let url = `MasterData/GetSpecificOrganizationMessageforGroup`;
      url += `?Group=Deposit Receipt`;
      return this.$http.get(url).then(({ data }) => {
        this.footerMessage = data.length ? data[0] : {};
      });
    },
  },
};
</script>
<template>
  <div class="w-full flex flex-wrap">
    <tail-address-header></tail-address-header>
    <div class="w-full p-1 text-center my-3">
      <h5 class="font-medium text-base uppercase">Deposit Receipt</h5>
    </div>
    <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">Name: {{ patient.names }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">MRN: {{ patient.patienT_ID }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">IP NO: {{ patient.ipfileno }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">OP NO: {{ patient.opfileno }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">VisitNO: {{ patient.visitNo }}</h5>
      </div>
      <div class="w-full my-1">
        <h5 class="text-sm font-medium">
          P Mode: {{ patientDeposits.length ? patientDeposits[0].mode : `-` }}
        </h5>
      </div>
    </div>
    <div class="w-full text-center my-1">
      <h5 class="font-bold uppercase text-base">
        Receipt No: {{ $route.query.ReceiptNo }}
      </h5>
    </div>
    <table class="table">
      <thead class="text-sm">
        <tr>
          <th class="p-tiny">Receipt No</th>
          <th class="p-tiny">Trx Date</th>
          <th class="p-tiny">Amount</th>
          <th class="p-tiny">Unallocated</th>
          <th class="p-tiny">Allocated</th>
          <th class="p-tiny">Memo</th>
        </tr>
      </thead>
      <tbody class="text-xs">
        <tr v-for="(patientDeposit, idx) in patientDeposits" :key="idx">
          <td class="p-tiny">{{ patientDeposit.receiptNo }}</td>
          <td class="p-tiny">{{ patientDeposit.trxDate | dateFormat }}</td>
          <td class="p-tiny">
            {{ patientDeposit.depositAmount | numberFormat }}
          </td>
          <td class="p-tiny">
            {{ patientDeposit.unAllocatedAmount | numberFormat }}
          </td>
          <td class="p-tiny">
            {{ patientDeposit.amountAllocated | numberFormat }}
          </td>
          <td class="p-tiny">{{ patientDeposit.trxMemo || `-` }}</td>
        </tr>
        <tr>
          <th colspan="6" class="p-1 text-center uppercase">
            Total Amount: {{ totalAmount | numberFormat }}
          </th>
        </tr>
      </tbody>
    </table>
    <div class="w-full my-1 text-right">
      <h5 class="text-xs font-medium capitalize">
        Served By:
        {{ patientDeposits.length ? patientDeposits[0].userName : `` }}
      </h5>
    </div>
    <div class="w-full p-1 text-center">
        <h5 class="font-medium text-sm italic">{{ footerMessage.message }}</h5>
    </div>
  </div>
</template>
